import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-verticals-content',
    templateUrl: './verticals-content.component.html',
    styleUrls: ['./verticals-content.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VerticalsContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
